import { useQueries } from '@tanstack/react-query';
import { StatsResult } from 'api/useAnalytics';
import { EQueryKeys } from 'constants/enums';
import useAxios from 'hooks/useAxios';

import { BUSINESS_ANALYTICS } from '../../utils';

interface UseStatsQueriesProps {
  publisherId?: string;
  selectedAttributeName?: string;
  selectedAttributeValues: string[];
  apiDateRange?: {
    from?: string;
    to?: string;
  };
}

export const useStatsQueries = ({
  publisherId,
  selectedAttributeName,
  selectedAttributeValues,
  apiDateRange,
}: UseStatsQueriesProps) => {
  const axios = useAxios();

  return useQueries({
    queries: selectedAttributeValues.map(value => {
      return {
        queryKey: [`${EQueryKeys.ANALYTICS}_${apiDateRange?.from}_${apiDateRange?.to}_${JSON.stringify({ [selectedAttributeName!]: [value] })}`],
        queryFn: async (): Promise<StatsResult[]> => {
            if (!apiDateRange?.from || !apiDateRange?.to) return [];
            const data = await axios.get('/dashboard/analytics/stats', {
                startDate: apiDateRange.from,
                endDate: apiDateRange.to,
                metrics: BUSINESS_ANALYTICS,
                attributeFilters: { [selectedAttributeName!]: [value] }
            }, publisherId ? { 'x-publishers': publisherId } : undefined);
            return data.stats;
        },
        enabled: !!publisherId && !!selectedAttributeName && selectedAttributeValues.length > 0,
      }
    })
  });
}; 